import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './QuickLinks.css';

const QuickLinks: React.FC = () => {
  const { t } = useTranslation();
  
  const quickLinks = [
    { nameKey: 'navigation.home', path: '/' },
    { nameKey: 'navigation.products', path: '/products' },
    { nameKey: 'navigation.categories', path: '/categories' },
    { nameKey: 'navigation.search', path: '/search' },
    { nameKey: 'footer.checkout', path: '/checkout' },
    { nameKey: 'navigation.cart', path: '/cart' }
  ];

  return (
    <div className="quick-links">
      <h4 className="links-title">{t('footer.quickLinks.title')}</h4>
      <ul className="links-list">
        {quickLinks.map((link, index) => (
          <li key={index} className="links-item">
            <Link to={link.path} className="links-link">
              {t(link.nameKey)}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuickLinks;
